import { render, staticRenderFns } from "./BiaodiSwiper.vue?vue&type=template&id=6859932e&scoped=true&"
import script from "./BiaodiSwiper.vue?vue&type=script&lang=js&"
export * from "./BiaodiSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BiaodiSwiper.vue?vue&type=style&index=0&id=6859932e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859932e",
  null
  
)

export default component.exports